import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Typography,
  Button
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import classes from './SubmissionValidator.module.scss'

export default function SubmissionValidator(props) {
  const { openDialog, title, close, handeSave, CAStatus } = props
  return (
    <Dialog
      fullWidth
      maxWidth='xs'
      onClose={close}
      aria-labelledby='customized-dialog-title'
      open={openDialog}
      className={classes.successroot}
      PaperProps={{ style: { display: 'flex' } }}
    >
      <div className={classes.beam}>
        <Typography className={classes['title-header']}>
          {title}
        </Typography>
        <IconButton
          aria-label='close'
          id='success-close-button'
          className={classes['close-button']}
          onClick={close}
        >
          <Close />
        </IconButton>
      </div>
      <DialogContent>
        <Grid constainer style={{ marginTop: '30px', marginBottom: '50px', marginLeft: '20px', marginRight: '10px' }}>
          <div className={classes.header}>
            <Typography className={classes['title']}>
              {CAStatus === 'partial' ? 'is this for partial liquidation and you will submit another liquidation?'
                : 'Are you sure you want to submit this transaction?'}
            </Typography>
          </div>
        </Grid>

        <div className={classes.button}>
          <Button
            variant='contained'
            className={classes['button-positive']}
            onClick={() => {
              handeSave()
              close()
            }}
          >
            OK
          </Button>
          <Button
            variant='contained'
            className={classes['button-negative']}
            onClick={close}
          >
            cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog >
  )
}
